export default __webpack_public_path__ + "static/media/building-with-coins-infront.f6fd5bc2.svg";